var _defs, _rect, _rect2, _g, _g2, _path, _g3, _g4, _g5, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHealth360(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "svg-flag": "true",
    mlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    zoomAndPan: "magnify",
    viewBox: "0 0 1296 1295.99994",
    height: 48,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "a21b215979"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 217 377 L 650 377 L 650 1124.101562 L 217 1124.101562 Z M 217 377 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ad62e458fb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 218 129.601562 L 1078 129.601562 L 1078 626 L 218 626 Z M 218 129.601562 ",
    clipRule: "nonzero"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -129.6,
    width: 1555.2,
    fill: "#ffffff",
    y: -129.599994,
    height: 1555.199927,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -129.6,
    width: 1555.2,
    fill: "inherit",
    y: -129.599994,
    height: 1555.199927,
    fillOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a21b215979)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b8f4ef",
    d: "M 648.078125 1122.902344 L 649.246094 1123.542969 L 648.078125 1124.246094 L 218.839844 876.371094 L 217.441406 875.554688 L 217.441406 378.289062 L 218.839844 377.472656 L 648.078125 625.34375 L 649.246094 624.644531 L 649.421875 624.820312 L 648.078125 625.578125 Z M 648.078125 1122.902344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ad62e458fb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d9d9d9",
    d: "M 1077.375 377.472656 L 649.246094 624.644531 L 648.078125 625.34375 L 218.839844 377.472656 L 648.078125 129.601562 Z M 1077.375 377.472656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#117bbc",
    d: "M 1078.773438 378.289062 L 1078.773438 875.554688 L 1077.375 876.371094 L 649.246094 1123.542969 L 648.078125 1122.902344 L 648.078125 625.578125 L 649.421875 624.820312 L 1077.609375 377.589844 Z M 1078.773438 378.289062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#010d19",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(418.211489, 448.983231)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 10.46875 -159.671875 C 23.414062 -171.460938 41.765625 -177.359375 65.515625 -177.359375 C 82.285156 -177.359375 95.734375 -173.742188 105.859375 -166.515625 C 115.992188 -159.296875 121.0625 -149.875 121.0625 -138.25 C 121.0625 -126.625 117.613281 -117.238281 110.71875 -110.09375 C 103.832031 -102.957031 95.90625 -99.140625 86.9375 -98.640625 C 97.394531 -96.648438 106.523438 -92.082031 114.328125 -84.9375 C 122.960938 -76.96875 127.363281 -65.757812 127.53125 -51.3125 C 127.53125 -41.507812 125.207031 -32.375 120.5625 -23.90625 C 111.925781 -8.300781 96.894531 2.90625 75.46875 9.71875 C 66.507812 12.539062 56.960938 13.953125 46.828125 13.953125 C 34.703125 13.953125 22.992188 11.957031 11.703125 7.96875 L 12.203125 5.484375 C 13.035156 5.484375 13.867188 5.484375 14.703125 5.484375 C 27.148438 5.484375 38.9375 3.160156 50.0625 -1.484375 C 61.1875 -6.140625 70.195312 -13.117188 77.09375 -22.421875 C 83.988281 -31.722656 87.4375 -42.265625 87.4375 -54.046875 C 87.4375 -74.304688 77.472656 -87.34375 57.546875 -93.15625 C 51.898438 -94.820312 45.835938 -95.65625 39.359375 -95.65625 L 39.859375 -98.140625 C 40.359375 -98.140625 40.769531 -98.140625 41.09375 -98.140625 C 52.382812 -98.140625 62.140625 -101.957031 70.359375 -109.59375 C 78.585938 -117.238281 82.703125 -126.457031 82.703125 -137.25 C 82.703125 -147.382812 79.878906 -154.859375 74.234375 -159.671875 C 68.585938 -164.484375 61.941406 -166.890625 54.296875 -166.890625 C 33.710938 -166.890625 23.421875 -153.9375 23.421875 -128.03125 C 23.421875 -126.875 23.421875 -125.628906 23.421875 -124.296875 L 20.921875 -124.296875 Z M 10.46875 -159.671875 "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#010d19",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(558.448834, 448.983231)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 81.453125 -93.15625 C 74.804688 -93.15625 69.078125 -90.832031 64.265625 -86.1875 L 62.515625 -88.171875 C 67.171875 -95.816406 74.066406 -101.382812 83.203125 -104.875 C 88.515625 -106.863281 93.578125 -107.859375 98.390625 -107.859375 C 103.203125 -107.859375 107.644531 -107.398438 111.71875 -106.484375 C 115.789062 -105.578125 119.898438 -103.789062 124.046875 -101.125 C 138.328125 -91.832031 145.46875 -76.640625 145.46875 -55.546875 C 145.46875 -38.941406 139.90625 -24.992188 128.78125 -13.703125 C 117.15625 -2.078125 100.753906 3.734375 79.578125 3.734375 C 58.410156 3.734375 41.929688 -2.78125 30.140625 -15.8125 C 18.347656 -28.851562 12.453125 -48.078125 12.453125 -73.484375 C 12.453125 -106.523438 21.585938 -133.257812 39.859375 -153.6875 C 48.828125 -163.65625 59.953125 -171.046875 73.234375 -175.859375 C 86.515625 -180.671875 100.796875 -183.078125 116.078125 -183.078125 C 118.566406 -183.078125 121.140625 -182.992188 123.796875 -182.828125 L 124.796875 -181.09375 C 101.546875 -173.78125 84.273438 -163.316406 72.984375 -149.703125 C 63.347656 -137.910156 57.367188 -121.800781 55.046875 -101.375 C 54.210938 -92.90625 53.796875 -82.773438 53.796875 -70.984375 C 53.796875 -49.734375 55.707031 -33.957031 59.53125 -23.65625 C 63.351562 -13.363281 70.328125 -8.21875 80.453125 -8.21875 C 86.929688 -8.21875 92.25 -10.378906 96.40625 -14.703125 C 103.539062 -22.171875 107.109375 -34.539062 107.109375 -51.8125 C 107.109375 -77.21875 100.21875 -90.832031 86.4375 -92.65625 C 84.769531 -92.988281 83.109375 -93.15625 81.453125 -93.15625 Z M 81.453125 -93.15625 "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#010d19",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(715.126094, 448.983231)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 30.140625 -153.3125 C 42.597656 -169.675781 59.660156 -177.859375 81.328125 -177.859375 C 102.992188 -177.859375 120.054688 -169.675781 132.515625 -153.3125 C 144.972656 -136.957031 151.203125 -114.910156 151.203125 -87.171875 C 151.203125 -59.441406 144.972656 -37.398438 132.515625 -21.046875 C 120.054688 -4.691406 102.992188 3.484375 81.328125 3.484375 C 59.660156 3.484375 42.597656 -4.691406 30.140625 -21.046875 C 17.679688 -37.398438 11.453125 -59.441406 11.453125 -87.171875 C 11.453125 -114.910156 17.679688 -136.957031 30.140625 -153.3125 Z M 81.453125 -167.390625 C 67.671875 -167.390625 58.375 -155.429688 53.5625 -131.515625 C 51.226562 -119.566406 50.0625 -104.789062 50.0625 -87.1875 C 50.0625 -60.78125 52.71875 -40.804688 58.03125 -27.265625 C 63.351562 -13.734375 71.117188 -6.96875 81.328125 -6.96875 C 91.535156 -6.96875 99.296875 -13.734375 104.609375 -27.265625 C 109.929688 -40.804688 112.59375 -60.773438 112.59375 -87.171875 C 112.59375 -113.578125 109.929688 -133.546875 104.609375 -147.078125 C 99.296875 -160.617188 91.578125 -167.390625 81.453125 -167.390625 Z M 81.453125 -167.390625 "
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.67082, 0.33541, -0.33541, 0.67082, 219.619816, 381.34067)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00103179 9.000757 L 0.00103179 9.000757 ",
    stroke: "#000000",
    strokeWidth: 18,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.585652, 0.468521, -0.468521, 0.585652, 217.538171, 386.206674)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00122578 2.000606 L 0.00122578 2.000606 ",
    stroke: "#000000",
    strokeWidth: 4,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.650684, 0.372975, -0.372975, 0.650684, 222.976095, 375.486276)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00291971 9.00035 L 658.35345 8.998648 ",
    stroke: "#000000",
    strokeWidth: 18,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.00226819, 0.749997, -0.749997, 0.00226819, 653.246805, 628.173861)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00138141 9.000994 L 661.322174 9.000994 ",
    stroke: "#000000",
    strokeWidth: 18,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.650611, -0.373102, 0.373102, 0.650611, 645.199197, 619.004517)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00213494 9.000238 L 652.693115 9.001513 ",
    stroke: "#000000",
    strokeWidth: 18,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth360);
export default __webpack_public_path__ + "static/media/health360.ca6b01a7759f9df74b799a74414cebed.svg";
export { ForwardRef as ReactComponent };